import {observer} from "mobx-react-lite";
import React, {Fragment, useState} from "react";
import {
    Button,
    Form,
    DatePicker,
    Modal,
    Space,
    Row,
    Col,
    Upload,
    UploadFile,
    GetProp,
    UploadProps,
    message,
    Card,
    Input, TreeSelect
} from "antd";
import {LanguageManageStore} from "../../../store";
import {PlusOutlined, UploadOutlined, MinusCircleOutlined} from "@ant-design/icons";
import {UploadChangeParam} from "antd/lib/upload/interface";

function UpdateOrAdd() {
    const form = Form.useFormInstance();

    const getFormData = (changeValue: any, allValues: any) => {
        // console.log(JSON.stringify(JSON.parse(allValues)))
        allValues.id = LanguageManageStore.languageData.id;
        changeValue.talkScriptDetails = allValues.talkScriptDetails
        changeValue.status = LanguageManageStore.languageData.status
        LanguageManageStore.setLanguageData({...allValues, ...changeValue});
    };
    const submitPower = () => {
        if (LanguageManageStore.addOrUpdateModal.update) {
            LanguageManageStore.updateLanguage({
                ...LanguageManageStore.languageData,
                sendAudit: LanguageManageStore.sendAudit
            });
        } else {
            LanguageManageStore.addLanguage({
                ...LanguageManageStore.languageData,
                sendAudit: LanguageManageStore.sendAudit
            });
        }
    };
    type FileType = Parameters<GetProp<UploadProps, "beforeUpload">>[0];
    const [previewOpen, setPreviewOpen] = useState(false);
    const [previewImage, setPreviewImage] = useState("");
    const getBase64 = (file: FileType): Promise<string> =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result as string);
            reader.onerror = (error) => reject(error);
        });
    const uploadButton = (
        <button style={{border: 0, background: "none"}} type="button">
            <PlusOutlined/>
            <div style={{marginTop: 8}}>Upload</div>
        </button>
    );
    const handlePreview = async (file: UploadFile) => {
        if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj as FileType);
        }
        setPreviewImage(file.url || (file.preview as string));
        setPreviewOpen(true);
    };
    const changePdfFile = ({file, fileList: newFileList}: any, name: string) => {
        // console.log(file)
        LanguageManageStore.setpdfList(LanguageManageStore[name as keyof typeof LanguageManageStore].filter((f: any) => (f.objectName !== file.originFileObj?.objectName&&f.objectName !== file?.objectName)), name);
    };
    const pdfBeforeUpload = (file: any, name: string) => {
        if (
            file.type !== "application/pdf" &&
            file.type !== "application/msword" &&
            file.type !==
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document" &&
            file.type !== "application/vnd.ms-excel" &&
            file.type !==
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" &&
            file.type !== "text/plain"
        ) {
            message.error("请上传PDF文件、DOC/DOCX、TXT或excel文件");
            return Upload.LIST_IGNORE;
        } else {
            LanguageManageStore.temporaryUpload(file, name);
        }
        return false;
    };

    return (
        <Fragment>
            <Modal
                width={620}
                centered
                title={LanguageManageStore.addOrUpdateModal.update ? "编辑" : "新增"}
                open={LanguageManageStore.addOrUpdateModal.isOpen}
                destroyOnClose={true}
                onCancel={() => LanguageManageStore.addOrUpdateModal.close()}
                footer={null}
            >
                <div style={{ maxHeight: "calc(75vh)", overflow: "auto" }}>
                    <Form
                        form={form}
                        labelCol={{span:6}}
                        labelWrap
                        initialValues={LanguageManageStore.languageData}
                        wrapperCol={{span:18}}
                        onValuesChange={getFormData}
                        onFinish={submitPower}
                        style={{marginTop: '20px',maxHeight:'80%'}}
                    >
                        <Row>
                            {LanguageManageStore.addOrUpdateModal.update && <Col span={24}>
                                <Form.Item
                                    label='ID' name="id"
                                    rules={[{required: true}]}
                                    style={{display: 'none'}}
                                >
                                    <Input/>
                                </Form.Item>
                            </Col>}
                            <Col span={24}>
                                <Form.Item
                                    label="合同链"
                                    name="contractChain"
                                    rules={[{required: true, message: "请上传"}]}
                                    valuePropName="fileList"
                                    getValueFromEvent={(e) => {
                                        if (Array.isArray(e)) {
                                            return e;
                                        }
                                        return e && e.fileList;
                                    }}
                                >
                                    <Upload
                                        fileList={LanguageManageStore.contractChain}
                                        onPreview={handlePreview}
                                        onChange={(e) => changePdfFile(e, "contractChain")}
                                        beforeUpload={(e) => pdfBeforeUpload(e, "contractChain")}
                                    >
                                        <Button icon={<UploadOutlined/>}>上传</Button>
                                        <span style={{fontSize: "12px"}}>
                       ( 仅支持格式PDF、DOC/DOCX、XLS/XLSX、TXT )
                    </span>
                                    </Upload>
                                </Form.Item>
                            </Col>
                            <Col span={24}>
                                <Form.Item
                                    label="到期时间" name="expireDate"
                                    rules={[{required: true, message: "请选择到期时间"}]}
                                >
                                    <DatePicker placeholder="请选择到期时间"/>
                                </Form.Item>
                            </Col>
                            {LanguageManageStore.addOrUpdateModal.add && <Col span={23}>
                                <Form.Item
                                    label="话术"
                                    name="talkScriptDetails"
                                    rules={[{required: true, message: "请至少填写一个话术"}]}
                                >
                                    <Form.List name="talkScriptDetails">
                                        {(fields, {add, remove}) => (
                                            <div
                                                style={{
                                                    display: "flex",
                                                    rowGap: 16,
                                                    flexDirection: "column",
                                                }}
                                            >
                                                {fields.map((field) => (
                                                    <Card
                                                        size="small"
                                                        title={`话术${field.name + 1}`}
                                                        key={field.key}
                                                        extra={
                                                            <MinusCircleOutlined
                                                                onClick={() => {
                                                                    remove(field.name);
                                                                }}
                                                            />
                                                        }
                                                    >
                                                        <Form.Item
                                                            label="报备场景"
                                                            name={[field.name, "sceneId"]}
                                                            rules={[
                                                                {required: true, message: "请选择报备场景"},
                                                            ]}
                                                        >
                                                            <TreeSelect
                                                                showSearch
                                                                style={{width: "100%"}}
                                                                dropdownStyle={{maxHeight: 400, overflow: "auto"}}
                                                                placeholder="请选择报备场景"
                                                                allowClear
                                                                treeDefaultExpandAll
                                                                fieldNames={{value: "sceneId"}}
                                                                treeData={LanguageManageStore.accountSceneList}
                                                                maxTagCount="responsive"
                                                            />
                                                        </Form.Item>

                                                        <Form.Item
                                                            label="话术内容"
                                                            name={[field.name, "content"]}
                                                            rules={[
                                                                {required: true, message: "请输入话术内容"},
                                                            ]}
                                                        >
                                                            <Input.TextArea
                                                                placeholder="请输入话术内容"
                                                                maxLength={2000}
                                                                showCount
                                                                rows={3}
                                                            />
                                                        </Form.Item>
                                                    </Card>
                                                ))}

                                                <Button type="dashed" onClick={() => add()} block>
                                                    + 新增一条话术
                                                </Button>
                                            </div>
                                        )}
                                    </Form.List>
                                </Form.Item>
                            </Col>}
                            {LanguageManageStore.addOrUpdateModal.update && <Col span={24}>
                                <Form.Item
                                    label='场景类型' name="sceneId"
                                    rules={[{required: true, message: '请选择场景类型'}]}
                                >
                                    <TreeSelect
                                        showSearch
                                        style={{width: "100%"}}
                                        dropdownStyle={{maxHeight: 400, overflow: "auto"}}
                                        placeholder="请选择报备场景"
                                        allowClear
                                        treeDefaultExpandAll
                                        fieldNames={{value: "sceneId"}}
                                        treeData={LanguageManageStore.accountSceneList}
                                        maxTagCount="responsive"
                                    />
                                </Form.Item>
                            </Col>}
                            {LanguageManageStore.addOrUpdateModal.update && <Col span={24}>
                                <Form.Item
                                    label='话术内容' name="content"
                                    rules={[{required: true, message: '请输入话术内容'}]}
                                >
                                    <Input.TextArea placeholder="请输入话术内容，限2000字" showCount maxLength={2000}/>
                                </Form.Item>
                            </Col>}
                        </Row>

                        <Form.Item wrapperCol={{span: 14, offset: 5}}>
                            <div style={{display: 'flex', justifyContent: 'space-between'}}>

                                {(LanguageManageStore.addOrUpdateModal.add || LanguageManageStore.languageData.status === 'DRAFT' || LanguageManageStore.languageData.status === 'WAIT_AUDIT') &&
                                    <Button type="primary" htmlType="submit"
                                            onClick={() => LanguageManageStore.setSendAudit(false)}>
                                        保存
                                    </Button>}
                                <Button type="primary" htmlType="submit"
                                        onClick={() => LanguageManageStore.setSendAudit(true)}>
                                    保存并发起审核
                                </Button>
                                <Button
                                    htmlType="reset"
                                    onClick={() => LanguageManageStore.addOrUpdateModal.close()}
                                >
                                    取消
                                </Button>
                            </div>
                        </Form.Item>
                    </Form>
                </div>
            </Modal>
        </Fragment>
    );
}

export default observer(UpdateOrAdd);
